export { DepositsFromSalesTable } from './DepositsFromSalesTable'
